import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import {
  FALLBACK_LANGUAGE,
  LOCALE_MAP,
  SUPPORTED_LANGUAGES,
} from "utils/constants/locales.constants";

const loadLocale = async (language: SUPPORTED_LANGUAGES) => {
  const locale = Object.values(SUPPORTED_LANGUAGES).includes(language)
    ? language
    : FALLBACK_LANGUAGE;

  await LOCALE_MAP[locale]();
  dayjs.locale(locale);
};

export const useDayjsLocalization = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    loadLocale(i18n.language as SUPPORTED_LANGUAGES);
  }, [i18n.language]);
};
